import React from "react";
import { Typography } from "@material-ui/core";

var HeaderViewer = function HeaderViewer(content) {
  // console.log("content headerviewer", content);
  var logicContent = function logicContent() {
    if (content && content.content && content.content.blocks) {
      // console.log(
      //   "content",
      //   content.content.blocks.filter(block =>
      //     block.type.includes("header-") ? true : false
      //   )
      // );
      return content.content.blocks.filter(function (block) {
        return block.type.includes("header-");
      }).map(function (block) {
        var spaces = block.type.substring(7, block.type.length);
        var marginLeft;

        switch (spaces) {
          case "one":
            marginLeft = "0px";
            break;

          case "two":
            marginLeft = "16px";
            break;

          case "three":
            marginLeft = "32px";
            break;

          case "four":
            marginLeft = "48px";
            break;

          case "five":
            marginLeft = "64px";
            break;

          case "six":
            marginLeft = "80px";
            break;

          default:
            break;
        }

        return /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          style: {
            marginLeft: marginLeft,
            wordWrap: "break-word"
          }
        }, block.text);
      });
    }

    return null;
  };

  return logicContent();
};

export { HeaderViewer };